import styled, {css} from 'styled-components';

import {gts} from '../../styles';
import {Text} from '../../uikit/Text';
import {View} from '../../uikit/View';
import {platform} from '../../utils/platform';

export const Container = styled(View)`
  flex-direction: column;
  flex: 1;
  height: 100%;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  gap: ${gts('gap.xl')};

  ${platform.isWeb &&
  css`
    min-height: 100vh;
  `}
`;

export const Title = styled(Text).attrs({
  variant: 'h2',
  weight: 'bold',
})`
  text-align: center;
`;

export const Description = styled(Text).attrs({
  variant: 'body',
})`
  max-width: 50%;
  text-align: center;
`;
